import request from '@/services/base-service';
import type { RequestDTO } from '@/types/step';
import { InternalAxiosRequestConfig } from 'axios';
import { PerspectiveDTO } from '@/types/step';
// port 7329
const baseUrl = '/v1/perspective';
export const perspectiveApi = {
  // Lấy danh sách perspective
  //giai doan 
  list: (requestDTO: RequestDTO) =>
    request.post(`${baseUrl}/list`, requestDTO, { authorization: true } as InternalAxiosRequestConfig),
  // Tạo perspective
  create: (requestDTO: PerspectiveDTO) =>
    request.post(`${baseUrl}/create`, requestDTO, { authorization: true } as InternalAxiosRequestConfig),


  bulkSave: (requestDTO: RequestDTO) =>
    request.post(`${baseUrl}/updatethemestrategymap`, requestDTO, { authorization: true } as InternalAxiosRequestConfig),
}